export default __webpack_public_path__ + "static/media/sort-icon.e264447c.svg";